module.exports = __webpack_public_path__ + "background-3ef4649695b6bc42db9007f6bf8b719a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.jpg
// module id = 587
// module chunks = 1